import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/homePage',
  title: window.language['menu.homePage'],
  component: dynamicWrapper(app, [import('./model'),import('../Material/Material/model'),import('../ClientOnlineStatistics/model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/HomePage/index.js